import { useState, useEffect } from 'react';
import { ChatIcon } from '@primerai/icons';
import { Box, Text } from '@primerai/thread';
import { useSelector } from 'react-redux';
import {
  ButtonWrapper,
  NAVBAR_ICON_SIZE,
} from '../branding/Authenticated.styles';
import { setCustomerServiceUser } from './utils';
import config from '~/config';
import { INTERCOM_SELECTOR_ID, TEXT_SIZE } from '~/constants';
import { getCurrentUser, getIntercomHash } from '~/store/auth/selectors';
import { get } from '~/utils/object';
import useInterval from '~/utils/useInterval';

const useIntercomEnabled = () => {
  const [libraryLoaded, setLibraryLoaded] = useState(false);
  const hasSetting = config.CUSTOMER_SERVICE_PROVIDER === 'INTERCOM';
  useInterval(
    () => {
      const intercom = get<boolean>(window, 'Intercom', false);
      if (intercom) {
        setLibraryLoaded(true);
      }
    },
    libraryLoaded ? null : 100,
  );
  return hasSetting && libraryLoaded;
};

export const ChatLink = ({ size }: { size: TEXT_SIZE }) => {
  const intercomEnabled = useIntercomEnabled();
  if (intercomEnabled) {
    return (
      <Box id={INTERCOM_SELECTOR_ID} style={{ cursor: 'pointer' }}>
        <Text size={size}>Help</Text>
      </Box>
    );
  }
  return null;
};

export const ChatButton = () => {
  const intercomEnabled = useIntercomEnabled();
  if (intercomEnabled) {
    return (
      <ButtonWrapper id={INTERCOM_SELECTOR_ID}>
        <ChatIcon
          color="$grayScale.g3"
          height={NAVBAR_ICON_SIZE}
          width={NAVBAR_ICON_SIZE}
        />
      </ButtonWrapper>
    );
  }
  return null;
};

export const useCustomerService = () => {
  const currentUser = useSelector(getCurrentUser);
  const intercomHash = useSelector(getIntercomHash);
  const win = window as any; // because, by default, window does not have an intercomSettings property

  useEffect(() => {
    const current = win.intercomSettings ?? {};
    win.intercomSettings = {
      ...current,
      created_at: Date.now(),
      custom_launcher_selector: '#' + INTERCOM_SELECTOR_ID,
      feature_audience: 'g3',
      alignment: 'left',
      horizontal_padding: 82,
      hide_default_launcher: true,
    };
  }, []);

  useEffect(() => {
    if (currentUser) {
      setCustomerServiceUser({
        name: currentUser.name || currentUser.username,
        company: get(currentUser, 'orgAccount.description', ''),
        email: currentUser.email || currentUser.username,
        user_id: currentUser.key,
      });
    }
  }, [currentUser, win, intercomHash]);

  useEffect(() => {
    if (intercomHash) {
      const current = win.intercomSettings ?? {};
      win.intercomSettings = {
        ...current,
        user_hash: intercomHash,
      };
    }
  }, [intercomHash, win]);

  return null;
};
